'use client';

import * as SubframeCore from '@subframe/core';
import { FeatherBadgeInfo } from '@subframe/core';
import React from 'react';
import * as SubframeUtils from '../utils';
interface DataFieldHorizontalRootProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  label?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}
const DataFieldHorizontalRoot = React.forwardRef<HTMLDivElement, DataFieldHorizontalRootProps>(function DataFieldHorizontalRoot({
  icon = <FeatherBadgeInfo />,
  label,
  children,
  className,
  ...otherProps
}: DataFieldHorizontalRootProps, ref) {
  return <div className={SubframeUtils.twClassNames('flex w-full items-center gap-2', className)} ref={ref} {...otherProps}>
        <div className="flex w-32 flex-none items-center gap-2">
          {icon ? <SubframeCore.IconWrapper className="text-body font-body text-subtext-color">
              {icon}
            </SubframeCore.IconWrapper> : null}
          {label ? <span className="text-body font-body text-subtext-color line-clamp-1 shrink-0 grow basis-0">
              {label}
            </span> : null}
        </div>
        {children ? <div className="flex min-h-[32px] shrink-0 grow basis-0 items-center gap-2">
            {children}
          </div> : null}
      </div>;
});
export const DataFieldHorizontal = DataFieldHorizontalRoot;